import {ChatCommonActions, setWelcomeMsgResultAction, submitFeedbackAction} from "../actions/chat-common-actions";
import {fork, put, takeEvery} from "redux-saga/effects";
import {getWelcomeMsgApi, submitFeedbackApi} from "../common/api";
import {WelcomeMsg} from "../types/common-types";
import {FeedbackMsg, FeedbackReq} from "../types/chat-feedback-types";
import {addChatMsgAction, sendMessageAction} from "../actions/chat-msg-actions";
import {CONFIG, SESSION_ID, CHANNEL_ID_SESSION_NAME, FEEDBACK_SUCCESS, FEEDBACK_FAIL, BUDDY_MSG} from "../common/config";
import {applicationThemeAction} from "../actions/chat-setting-actions";
import { ChatMsg } from "src/types/chat-msg-types";
import {getParameterValueFromUrl} from "../utils/utils";
import {pareJson} from "../utils/jsonVerification";
import {
    getConversationSessionIdAction,
    loadHistoryBySessionAction,
} from "../actions/chat-msg-actions"

function* getWelcomeMsg() {
    console.log("get welcome message start");
    const url = getParameterValueFromUrl("url");
    const resp = yield getWelcomeMsgApi();
    
    if (resp && resp.status === "success") {
        const welcomeMsg: WelcomeMsg = {
            messageOne: resp.data.messageOne,
            messageTwo: resp.data.messageTwo,
            securityAlert: resp.data.securityAlert,
            typingMessage: (resp.data.typingMessage === "" || resp.data.typingMessage === null) ? "": resp.data.typingMessage,
            scheduleSecurityAlert: resp.data.scheduleSecurityAlert,
            securityAlertStartTime: resp.data.securityAlertStartTime,
            securityAlertEndTime: resp.data.securityAlertEndTime,
            buddyTextConfiguration: pareJson(resp.data?.buddyTextConfiguration)
        }
        yield put(setWelcomeMsgResultAction(welcomeMsg));
    }

    if (!sessionStorage.getItem(SESSION_ID) || sessionStorage.getItem(SESSION_ID) === 'undefined') {
        if (url) {
            yield put(getConversationSessionIdAction(true));
        } else {
            yield put(getConversationSessionIdAction(false));
        }
    } else {
        if (url) {
            yield put(loadHistoryBySessionAction(true));
        } else {
            yield put(loadHistoryBySessionAction());
        }
    }
}

function* submitFeedback(payload: any) {
    // let rating = payload.payload.rating;
    // let qid1 = rating === 1 ? {"1": {selected: true}} : rating === 2 ? {"2": {selected: true}} :
    //     rating === 3 ? {"3": {selected: true}} : rating === 4 ? {"4": {selected: true}} : rating === 5 ? {"5": {selected: true}} : {"5": {selected: true}};
    // let desc = payload.payload.desc;
    let surveyId = payload.payload.surveyId;
    const data: FeedbackReq = {
        "convId": payload.payload.convId,
        "surveyId": surveyId,
        "responses": {
            ...payload.payload,
            "sessionID": sessionStorage.getItem(SESSION_ID) ? sessionStorage.getItem(SESSION_ID) : "",
            "channelID": (sessionStorage.getItem(CHANNEL_ID_SESSION_NAME) ? sessionStorage.getItem(CHANNEL_ID_SESSION_NAME) : CONFIG.CHANNEL_ID) ?? "",
            "conversationID": payload.payload.convId ? payload.payload.convId.toString() : ""
        },
        frontEndActionCode: payload.payload.actionCode
    }


    const resp = yield submitFeedbackApi(data);
    localStorage.setItem("submitFeedback", "true");
    if (resp && resp.status === "success") {
        if(resp.data?.data && resp.data?.status === "success") {
            const buddyMsg: ChatMsg = {msg: resp.data.data, type: BUDDY_MSG, date: new Date(), convId: null};
            yield put(addChatMsgAction(buddyMsg));
        }else {
            yield put(sendMessageAction({message: "#feedback-success",type:FEEDBACK_SUCCESS, exactMatch: true, name: ""}));
        }
    } else {
        if(resp.data?.data && resp.data?.status === "success") {
            const buddyMsg: ChatMsg = {msg: resp.data.data, type: BUDDY_MSG, date: new Date(), convId: null};
            yield put(addChatMsgAction(buddyMsg));
        }else {
            yield put(sendMessageAction({message: "#feedback-fail",type:FEEDBACK_FAIL, exactMatch: true, name: ""}));
        }
    }

}

function* mySaga() {
    yield takeEvery(ChatCommonActions.GET_WELCOME_MESSAGE, getWelcomeMsg);
    yield takeEvery(ChatCommonActions.SUBMIT_FEEDBACK, submitFeedback);
}

const chatCommonSaga = [fork(mySaga)];

export default chatCommonSaga;